import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListCategory = (params, headers) => request.get('/api/v1/short-links', { params, ...headers });
export const getListScript = params => request.get('/api/v1/urls', { params });
export const createCategory = data => request.post('/api/v1/short-links', data);
export const createScript = data => request.post('/api/v1/ads/create-url', data);
export const updateScript = data => request.post('/api/v1/ads/update-url', data);
// export const updateCategory = data => request.post('/api/v1/categories/update', data);
export const updateCategory = data => request.post('/api/v1/short-links/update', data);
export const deleteCategory = data => request.post('/api/v1/short-links/delete', data);
export const deleteMutilShortlink = data => request.post('/api/v1/short-links/delete-multiple', data);
export const deleteScript = data => request.post('/api/v1/ads/delete-url', data);
export const deleteMutilScript = data => request.post('/api/v1/ads/delete-multiple-url', data);
export const setBestCategory = data => request.post('/api/v1/categories/set-best', data);
export const exportTemplate = (data) => request.post('/api/v1/categories/export-template', data, { responseType: 'arraybuffer' })
export const importFile = (data, config) =>
  request.post('/api/v1/short-links/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });

export const updateThumbnail = async data => {
  return await request.post('/api/v1/common/upload-thumbnail', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Mutation
export const useCreateCategoryMutation = () => useMutation({ mutationFn: createCategory });
export const useCreateScriptMutation = () => useMutation({ mutationFn: createScript });
export const useUpdateCategoryMutation = () => useMutation({ mutationFn: updateCategory });
export const useUpdateScriptMutation = () => useMutation({ mutationFn: updateScript });
export const useDeleteCategoryMutation = () => useMutation({ mutationFn: deleteCategory });
export const useDeleteMutilShortlinkMutation = () => useMutation({ mutationFn: deleteMutilShortlink });
export const useUpdateThumbnailMutation = () => useMutation({ mutationFn: updateThumbnail });
export const useSetBestCategoryMutation = () => useMutation({ mutationFn: setBestCategory });
export const useExportTemplateMutation = () => useMutation({ mutationFn: exportTemplate });
export const useDeleteScriptMutation = () => useMutation({ mutationFn: deleteScript });
export const useDeleteScriptMutilMutation = () => useMutation({ mutationFn: deleteMutilScript });
export const useExportShortlinkMutation = (params, headers) => useMutation({ mutationFn: () => getListCategory(params, headers) });

// Query
export const useQueryGetListCategory = (params = {}, options = {}) =>
  useQuery({ queryKey: ['getListCategory', params], queryFn: () => getListCategory(params), ...options });
export const useQueryGetListScript = (params = {}, options = {}) =>
  useQuery({ queryKey: ['getListScript', params], queryFn: () => getListScript(params), ...options });